export default "__VITE_ASSET__BuO6VPYE__"